/**
 * 该文件用于环境配置
 */


let ENV="";
const hostname = window.location.hostname

if(hostname== 'wap.test.tuanche.com'){
  ENV="PRE"
}else if(hostname== 'wap.tuanche.com'){
  ENV="PROD"
}else if(hostname=='t.wap.tuanche.com'){
  ENV="DEV"
}else{
  ENV="LOCAL"
}



// const ENV="PROD";
export {
  ENV
};



// WEBPACK FOOTER //
// ./static/js/config.js